module.exports = __webpack_public_path__ + "static/media/indian_snacks.736f1526.jpg";